<div class="app-cookies" [ngClass]="{'app-cookies--visible': showCookiesBanner}">
  <p>We use cookies to deliver superior functionality and to enhance your experience with our website.</p>
  <div class="app-cookies__actions">
    <button mat-stroked-button (click)="acceptCookies()">Accept Cookies</button>
    <button mat-stroked-button (click)="readMore()" [disabled]="isReadMoreDisabled">Read More</button>
  </div>
  <button mat-icon-button class="app-cookies__close" (click)="closeBanner()">
    <mat-icon>close</mat-icon>
  </button>
</div>
